<template>
    <HelpPopup v-if="hasAlerts" :label="coverageAlerts.length" icon="fa fa-warning" :muted="false" variant="danger"
        placement="left">
        <b-table-simple>
            <tbody>
                <tr v-for="ca in coverageAlerts">
                    <td>
                        <strong>
                            {{ referenceCodeLabel(ca.referenceCode) }}
                        </strong>
                        <div v-if="ca.referenceText">
                            {{ ca.referenceText }}
                        </div>
                    </td>
                </tr>
            </tbody>
        </b-table-simple>
    </HelpPopup>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import HelpPopup from '@/components/HelpPopup.vue';

@Component({
    name: "RTPBCoverageAlerts",
    components: {
        HelpPopup
    }
})
export default class RTPBCoverageAlerts extends Vue {
    @Prop({ required: true }) protected pricingCoverage!: any;

    get coverageAlerts() {
        return this.pricingCoverage.coverageAlerts;
    }

    get hasAlerts() {
        return !!this.coverageAlerts.length;
    }

    referenceCodeLabel(referenceCode: number) {
        switch (referenceCode) {
            case 0:
                return "Age Limits";
            case 1:
                return "Days Supply Exceeded";
            case 2:
                return "Drug Exclusion";
            case 3:
                return "Excessive Utilization";
            case 4:
                return "Full Cost Not Covered";
            case 5:
                return "Gender Limits";
            case 6:
                return "Mandatory Generic";
            case 7:
                return "Medical Necessity";
            case 8:
                return "Not on Formulary";
            case 9:
                return "Pharmacy Out of Network";
            case 10:
                return "Plan Limit Exclusion";
            case 11:
                return "Quantity Limits";
            case 12:
                return "Quantity Limit Exceeded";
            case 13:
                return "Quantity Not Valid";
            case 14:
                return "Resource Link";
            case 15:
                return "Step Therapy";
            default:
                return "";
        }
    }
}

</script>